<template>
    <b-modal
        v-model="userConfirmationNeeded"
        class="user-confirmation-needed-modal"
        title="Confirm Your Selection"
        size="lg"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        :hide-header-close="true"
        ok-title="Okay"
        ok-variant="orange"
        @cancel="() => undo()"
    >
        <your-selection />

        <div class="px-4">
            <div
                v-if="additionAffectedChromeOptions.length > 0"
                class="additions my-3"
            >
                <p>
                    <strong
                        >To {{ isAddition ? "add" : "remove" }} that feature,
                        you must also add:</strong
                    >
                </p>
                <hr />
                <div class="options">
                    <div
                        v-for="option in additionAffectedChromeOptions"
                        :key="option.chromeOptionCode"
                        class="option d-flex justify-content-between"
                    >
                        <div class="label">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-html="getName(option)" />
                            <i
                                v-if="hasDescription(option)"
                                :id="'popover-' + option.chromeOptionCode"
                                class="ion-ios-information-outline"
                                tabindex="-1"
                                aria-hidden="true"
                            />
                            <b-popover
                                v-if="hasDescription(option)"
                                :target="'popover-' + option.chromeOptionCode"
                                triggers="click blur"
                            >
                                <template slot="title">
                                    <div class="d-flex justify-content-between">
                                        <!-- eslint-disable-next-line vue/no-v-html -->
                                        <div
                                            class="name"
                                            v-html="getName(option)"
                                        />
                                        <div class="cost">
                                            {{
                                                getCost(option)
                                                    | numeral("$0,0")
                                            }}
                                        </div>
                                    </div>
                                </template>
                                <!-- eslint-disable-next-line vue/no-v-html -->
                                <div
                                    class="description-popover"
                                    v-html="getDescription(option)"
                                />
                            </b-popover>
                        </div>
                        <div class="cost">
                            {{ getCost(option) | numeral("$0,0") }}
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="deletionAffectedChromeOptions.length > 0"
                class="deletions my-3"
            >
                <p>
                    <strong
                        >To {{ isAddition ? "add" : "remove" }} that feature,
                        you must also remove:</strong
                    >
                </p>
                <hr />
                <div class="options">
                    <div
                        v-for="option in deletionAffectedChromeOptions"
                        :key="option.chromeOptionCode"
                        class="option d-flex justify-content-between"
                    >
                        <div class="label">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <span v-html="getName(option)" />
                            <i
                                v-if="hasDescription(option)"
                                :id="'popover-' + option.chromeOptionCode"
                                tabindex="-1"
                                class="ion-ios-information-outline"
                                aria-hidden="true"
                            />
                            <b-popover
                                v-if="hasDescription(option)"
                                :target="'popover-' + option.chromeOptionCode"
                                triggers="click blur"
                            >
                                <!-- eslint-disable-next-line vue/no-v-html -->
                                <div
                                    class="description-popover"
                                    v-html="getDescription(option)"
                                />
                            </b-popover>
                        </div>
                        <div class="cost">
                            {{ getCost(option) | numeral("$0,0") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style lang="scss">
.user-confirmation-needed-modal {
    .cost {
        font-family: $helvetica-55-Roman;
        color: $primary-blue;
        font-size: 16px;
    }

    strong {
        font-family: $helvetica-65-medium;
        font-weight: normal;
    }

    .description-popover {
        ul {
            margin: 0;
            padding-left: 20px;
        }
    }
}
.modal-footer {
    button {
        width: 155px !important;
        height: 40px !important;
    }
}
</style>

<script>
import modals from "Modules/Configure/mixins/modals";
import { get, sync } from "vuex-pathify";
import YourSelection from "Modules/Configure/components/Modal/YourSelection";

export default {
    components: { YourSelection },
    mixins: [modals],

    computed: {
        userConfirmationNeeded: sync("configure/userConfirmationNeeded"),
        additionAffectedChromeOptions: get(
            "configure/additionAffectedChromeOptions"
        ),
        deletionAffectedChromeOptions: get(
            "configure/deletionAffectedChromeOptions"
        )
    }
};
</script>
